module.exports = [{"type":"title","text":"2025-12-18"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"將合約模擬盤領取 VST 接口由 v1 升級為 v2(/openApi/swap/v2/trade/getVst)，支持增加與減少自定義金額。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-12-18.json
// module id = 4myO
// module chunks = 3